import { STATE_NAME } from './constants';
import reducer from './reducer';

export { STATE_NAME };
export default reducer;
